import { isEqual, reduce } from "lodash"
import { getQueryStringState, setQueryStringState } from "helpers/queryString"
import queryStringReducers from "../../../reducers/queryString"

const reduceQueryString = (currentState, action, reduxState) => {
  const reducers = queryStringReducers[action.type]
  if (reducers) {
    return reduce(reducers, (state, reducer) => reducer(state, action, reduxState), currentState)
  }
  return currentState
}

export const createQueryStringStoreMiddleware = navigate => store => next => action => {
  const currentState = getQueryStringState()
  const newState = reduceQueryString(currentState, action, store.getState())
  if (!isEqual(currentState, newState)) {
    setQueryStringState(navigate, newState)
  }

  return next(action)
}
